/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    ContentItem,
    ContentItemFromJSON,
    ContentItemToJSON,
} from './';

/**
 *
 * @export
 * @interface SearchZendeskResponse
 */
export interface SearchZendeskResponse {
    /**
     *
     * @type {number}
     * @memberof SearchZendeskResponse
     */
    total: number;
    /**
     *
     * @type {number}
     * @memberof SearchZendeskResponse
     */
    offset: number;
    /**
     *
     * @type {number}
     * @memberof SearchZendeskResponse
     */
    limit: number;
    /**
     *
     * @type {boolean}
     * @memberof SearchZendeskResponse
     */
    hasMore: boolean;
    /**
     *
     * @type {Array<ContentItem>}
     * @memberof SearchZendeskResponse
     */
    data: ContentItem[];
}

export function SearchZendeskResponseFromJSON(json: any): SearchZendeskResponse {
    return SearchZendeskResponseFromJSONTyped(json, false);
}

export function SearchZendeskResponseFromJSONTyped(json: any, _: boolean): SearchZendeskResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'total': json['total'],
        'offset': json['offset'],
        'limit': json['limit'],
        'hasMore': json['has_more'],
        'data': ((json['data'] as any[]).map(ContentItemFromJSON)),
    };
}

export function SearchZendeskResponseToJSON(value?: SearchZendeskResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'total': value.total,
        'offset': value.offset,
        'limit': value.limit,
        'has_more': value.hasMore,
        'data': ((value.data as any[]).map(ContentItemToJSON)),
    };
}
